'use client'

import { useState } from 'react'
import { useRouter } from 'next/navigation'
import { Button } from '@/components/ui/button'

export default function ResumeSatButton() {
  const router = useRouter()
  const [busy, setBusy] = useState(false)

  return (
    <Button
      data-src="sat-resume-v2"
      disabled={busy}
      onClick={() => {
        setBusy(true)
        router.push('/sat/resume')
      }}
    >
      {busy ? 'Opening…' : 'Resume'}
    </Button>
  )
}
